import React from 'react';
import { useTheme } from '@mui/material';
import { IconProps } from './IconProps.interface';

export function NoIncidentNotificationIcon(props: IconProps) {
  const theme = useTheme();
  const { height, width, opacity, fillColor, onClick } = props;

  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      viewBox="0 0 105 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="60.3215"
        cy="44.679"
        r="32.3183"
        transform="rotate(-32.8369 60.3215 44.679)"
        fill={theme.palette.primary.main}
      />
      <circle
        cx="12.8718"
        cy="47.1355"
        r="9.31077"
        transform="rotate(-32.8369 12.8718 47.1355)"
        fill={theme.palette.primary.main}
      />
      <path
        d="M58.8444 85.6591C69.9072 85.6591 80.5168 81.2645 88.3394 73.4419C96.162 65.6193 100.557 55.0097 100.557 43.9469C100.557 32.8841 96.162 22.2744 88.3394 14.4519C80.5168 6.62929 69.9072 2.23462 58.8444 2.23462"
        stroke={theme.palette.primary.main}
        strokeWidth="4.46917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="60" cy="44" r="15" fill={theme.palette.success.main} />
      <path
        d="M68.2561 38.0022L58.076 48.1942L53.8735 44.0037L51.752 46.1252L58.079 52.4373L70.3784 40.1237L68.2561 38.0022Z"
        fill="white"
      />
    </svg>
  );
}
